<template>
    <div class="uploader-hints">
        
    </div>
</template>